import React from 'react';
import { View, Text, Button, Icon, Switch, colors } from '@fairygodboss/ui';

export const JobsSearchResultsHeader = ({
    jobSearchQuery,
    totalJobs,
    onJobAlertSettingClick,
    alertToggleValue,
    onAlterToggleClick,
    totalJobAlerts,
    disableAlertToggle,
    isAuthenticatedUser,
    jobSearchLocation,
}) => {
    return (
        <View
            zIndex="1"
            position="sticky"
            top="0px"
            display="flex"
            justifyContent="space-between"
            bg="white"
            py="18px"
            pl="16px"
            borderBottomColor={colors.secondary[20]}
            borderBottomWidth="1px"
            borderBottomStyle="solid"
        >
            <View>
                {jobSearchQuery?.length ? (
                    <Text variant="bodyLg" as="div" fontWeight="700">
                        {jobSearchQuery}
                    </Text>
                ) : null}
                <Text
                    m="0"
                    pt="4px"
                    variant="bodySm"
                    as="div"
                    data-qa="Jobs-Search-Results-Header"
                >
                    Showing {totalJobs} matches
                    {jobSearchLocation?.length
                        ? ` in ${jobSearchLocation}`
                        : ''}
                    :
                </Text>
            </View>
            {isAuthenticatedUser ? (
                <View pt="7px" mt={disableAlertToggle ? '-12px' : '0px'}>
                    {!disableAlertToggle ? (
                        <Switch
                            disabled={disableAlertToggle}
                            justifyContent="end"
                            pr="16px"
                            checked={alertToggleValue}
                            label={`Alert ${alertToggleValue ? 'on' : 'off'}`}
                            labelMargin="0 8px 0 0"
                            onChange={onAlterToggleClick}
                        />
                    ) : null}
                    <Button
                        data-qa="Jobs-Search-Results-Alerts-button"
                        height="32px"
                        mt="4px"
                        size="small"
                        textCol
                        variant="secondaryText"
                        onPress={onJobAlertSettingClick}
                        py="6px"
                        px="16px"
                        css={{
                            span: {
                                display: 'flex',
                                color: colors.secondary[60],
                            },
                        }}
                    >
                        <Icon
                            outlineColor={colors.secondary[60]}
                            mr="6px"
                            variant="settings_16"
                            display="inline-grid"
                            paddingTop="1px"
                        />
                        {totalJobAlerts
                            ? `${totalJobAlerts} Job alerts`
                            : 'Set job alerts'}
                    </Button>
                </View>
            ) : null}
        </View>
    );
};
